import React from 'react';

export default function FullPageLoader({ message = 'Loading...' }) {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255,255,255,0.85)',
      zIndex: 1050,
      padding: 20
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner-border text-primary" role="status" style={{ width: 64, height: 64 }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div style={{ marginTop: 12, fontSize: 16, color: '#333' }}>{message}</div>
      </div>
    </div>
  );
}